import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { AnnouncementWithRelationsDto, ResponseDto } from "@mimber/schema"
import { announcementsKeys } from "../announcements.utils"
import type { PublishAnnouncementParams } from "./usePublishAnnouncement.types"

export const usePublishAnnouncement = (
  options?: UseMutationOptions<
    ResponseDto<AnnouncementWithRelationsDto>,
    Error,
    PublishAnnouncementParams
  >
): UseMutationResult<
  ResponseDto<AnnouncementWithRelationsDto>,
  Error,
  PublishAnnouncementParams
> => {
  guardAppUsage("mimber-organization", "usePublishAnnouncement")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async ({ uuid, sendNow }: PublishAnnouncementParams) => {
      const response = await server.post<
        ResponseDto<AnnouncementWithRelationsDto>
      >(`announcements/${uuid}/publish`, { sendNow })
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: announcementsKeys.findOne(variables.uuid),
      })
      queryClient.invalidateQueries({
        queryKey: announcementsKeys.findAll(),
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
